export default __webpack_public_path__ + "static/media/mail.902ae3cc.svg";